import { jsx as _jsx } from "react/jsx-runtime";
import { usePDF } from '@react-pdf/renderer';
import { BtwButton, BtwLink } from '@marvelapp/ballpark-components';
import { InsightsReportPdf } from './InsightsReportPdf';
export function InsightsReportPdfDownloadLink({ insightsData, insightsAnalysisData, }) {
    var _a;
    const [instance] = usePDF({
        document: (_jsx(InsightsReportPdf, { insightsData: insightsData, insightsAnalysisData: insightsAnalysisData })),
    });
    if (instance.error) {
        console.error(instance.error);
        return null;
    }
    return (_jsx(BtwButton, { asChild: true, variant: "ghost", size: "intermediate", disabled: instance.loading, children: _jsx(BtwLink, { variant: "secondary", href: (_a = instance.url) !== null && _a !== void 0 ? _a : '', underline: false, target: "_blank", children: instance.loading ? 'Generating PDF...' : 'Download PDF Report' }) }));
}
